import { Icon } from '@iconify/react'
import React from 'react'

type Props={
    title:string
    onRefresh?:() => void
    onAction?:() => void
    actionBtnLabel?:string
}

const Fallback:React.FC<Props> = ({title,actionBtnLabel='', onRefresh, onAction}) => {
  return (
    <div className='flex flex-col justify-center items-center gap-4 h-[60vh]'>
      <Icon icon="solar:calendar-bold-duotone" width={60} className='text-gray-700'/>
      {title}
      {onAction &&(
        <button type="button" className='h-8 rounded-md text-sm w-28 bg-green-800 text-white hover:bg-green-900'
      onClick={onAction}>
        {actionBtnLabel}</button>
      )}
       {onRefresh &&(
        <button type="button" className='h-8 rounded-md text-sm w-28 bg-green-800 text-white hover:bg-green-900'
      onClick={onRefresh}>
        Refresh</button>
      )} 
    </div>
  )
}

export default Fallback
